import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import {
  AgioOverrides,
  AgioOverridesUpdateDto,
  AgioSettings,
  AgioSettingsUpdateDto,
  EffectiveAgioSettings,
} from '@models/resources/agio.model';

/**
 * Agio-Verwaltung (User-Feedback P18) — globale Sätze pro Metall +
 * Abweichungen pro Kunde. Muster analog `AdminStorageFeesFacade`.
 *
 * - `getSettings()`/`saveSettings()`   → `GET|PATCH /agio/settings`
 * - `getOverrides()`/`saveOverrides()` → `GET|PATCH /customers/{id}/agio-overrides`
 * - `getEffective(id)`                 → `GET /customers/{id}/agio-overrides/effective`
 */
export interface AdminAgioFacade {
  getSettings(): Observable<AgioSettings>;
  saveSettings(dto: AgioSettingsUpdateDto): Observable<AgioSettings>;
  getOverrides(customerId: number): Observable<AgioOverrides>;
  saveOverrides(customerId: number, dto: AgioOverridesUpdateDto): Observable<AgioOverrides>;
  getEffective(customerId: number): Observable<EffectiveAgioSettings>;
}

export const ADMIN_AGIO_FACADE = new InjectionToken<AdminAgioFacade>('AdminAgioFacade');
